// extracted by mini-css-extract-plugin
var _1 = "VersionChangeCard-module__animateUploadProgressBarWidth--SrFVR";
var _2 = "VersionChangeCard-module__animatedBackground--GEF4g";
var _3 = "VersionChangeCard-module__authorName--kADvq";
var _4 = "VersionChangeCard-module__badge--HOR_u";
var _5 = "VersionChangeCard-module__compactAvatarContainer--vJFVo";
var _6 = "VersionChangeCard-module__content--w7Z7r";
var _7 = "VersionChangeCard-module__contentContainer--mzsEg";
var _8 = "VersionChangeCard-module__date--_KEAE";
var _9 = "VersionChangeCard-module__focused--ajn6e";
var _a = "VersionChangeCard-module__menuContainer--x2NCB";
var _b = "VersionChangeCard-module__muted--AvkZ1";
var _c = "VersionChangeCard-module__newBadgeContainer--l4O05";
var _d = "VersionChangeCard-module__open--a7BBZ";
var _e = "VersionChangeCard-module__popOverRoot--nqb7x";
var _f = "VersionChangeCard-module__popOverRootInner--wPmnz";
var _10 = "VersionChangeCard-module__root--vC49Z";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "authorName", _4 as "badge", _5 as "compactAvatarContainer", _6 as "content", _7 as "contentContainer", _8 as "date", _9 as "focused", _a as "menuContainer", _b as "muted", _c as "newBadgeContainer", _d as "open", _e as "popOverRoot", _f as "popOverRootInner", _10 as "root" }
